// @flow
import React, { Component } from 'react';

// eslint-disable-next-line import/no-extraneous-dependencies
import { ToastContainer, toast, Slide } from 'react-toastify';
import { connect } from 'react-redux';
import type { AuthState } from '../store/reducers/auth';

/*
  Parameters:
    message: The message to display in a toast
    toastType: Determines the color of the notification. Possible values: default, info, success, warning, error
    containerIds: An array of container ids (which identify each ToastContainer component) that the message
    should be displayed inside
*/
export function notify(message, toastType, containerIds = []) {
  let type = toastType;
  if (!(toastType.toUpperCase() in toast.TYPE)) {
    type = toast.TYPE.DEFAULT;
  }
  if (containerIds && containerIds.length) {
    containerIds.forEach((containerId) => toast(message, {
      containerId, type
    }));
  } else {
    toast(message, { containerId: 'all', type });
  }
}

type Props = {
  containerId: string,
  auth: AuthState
};

class ToastNotification extends Component {
  props: Props;

  render() {
    return (
      this.props.auth.authenticated &&
        <ToastContainer
          enableMultiContainer
          containerId={this.props.containerId}
          hideProgressBar
          transition={Slide}
          closeButton={false}
        />
    );
  }
}

const mapStateToProps = (appState: { auth: AuthState }) => ({
  auth: appState.auth
});

export default connect(mapStateToProps, {})(ToastNotification);


// WEBPACK FOOTER //
// ./src/components/toast.js